import React from 'react';
import { CCard, CCardHeader, CCardBody, CLabel, CFormGroup, CForm, CCardTitle, CTooltip, CImg, CInput } from '@coreui/react';
import { get } from 'lodash';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import Select from '../../shared/components/form/select/Select';
import tooltip from '../../assets/images/tool_tip.svg';
import { CustomizationFormProps } from '../types';

export const LABELS_AGENT_OPTIONS = [
  {
    value: 'Technician',
    label: 'Technician',
  },
  {
    value: 'Driver',
    label: 'Driver',
  },
];

export const LABELS_TASK_OPTIONS = [
  {
    value: 'Appointment',
    label: 'Appointment',
  },
  {
    value: 'Delivery',
    label: 'Delivery',
  },
];

const LabelsForm = () => {
  const formik = useFormikContext();
  const errors = formik.errors as CustomizationFormProps;

  const isInvalid = (fieldName: string) => get(formik.touched, fieldName) && get(formik.errors, fieldName);

  return (
    <CForm onSubmit={formik.handleSubmit}>
      <CCard className="glympser-container--roundedWithShadow">
        <CCardHeader className="glympser-roundedTop">
          <div className="d-flex align-items-center justify-content-between">
            <CCardTitle className="m-0">
              Labels
            </CCardTitle>
          </div>
        </CCardHeader>
        <CCardBody>
          <CFormGroup>
            <CLabel htmlFor="agent">Agent Label</CLabel>
            <CInput
              name="agent"
              id="agent"
              placeholder='Type agent label'
              className={classNames({ 'is-invalid': isInvalid('agent') })}
              {...formik.getFieldProps('agent')}
            />
            {isInvalid('agent') && <div className="invalid-feedback">{errors.agent}</div>}
          </CFormGroup>
          <CFormGroup>
            <CLabel htmlFor="destination.title">Task Label</CLabel>
            <CTooltip placement="top"
                      content="Select between “Delivery” and “Appointment” in your system and customer communications.">
              <CImg src={tooltip} className="ml-2 glympser-toolTip" />
            </CTooltip>
            <Select
              isMulti={false}
              name="task"
              id="task"
              options={LABELS_TASK_OPTIONS}
              className={classNames({ 'is-invalid': isInvalid('task') })}
              classNamePrefix="select"
              {...formik.getFieldProps('task')}
              onBlur={() => formik.setFieldTouched('task', true, true)}
              onChange={(values) => formik.setFieldValue('task', values)}
            />
            {isInvalid('task') && <div className="invalid-feedback">{errors.task}</div>}
          </CFormGroup>
        </CCardBody>
      </CCard>
    </CForm>
  );
};

export default LabelsForm;
